export default __webpack_public_path__ + "media/6d7d5581ccdca176d823d49f022396b01a6bb9a940d25da1c80f9368147e1007.svg";